"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var WithErrorHandler_1 = require("../../components/WithErrorHandler");
var Index = function (props) {
    var successRelate = react_1.useMemo(function () { return props.successRelate; }, [props.successRelate]);
    var onClickClose = react_1.useCallback(function () {
        if (typeof props.onClickClose !== 'undefined') {
            props.onClickClose();
        }
    }, []);
    return react_1.default.createElement("div", { className: 'newcar-askcontent-success' },
        successRelate && successRelate.showSuccessIcon && react_1.default.createElement("img", { src: "//icon.xgo-img.com.cn/topic/22010517/secuss.png", className: 'success-icon', alt: "" }),
        successRelate.successTitle && react_1.default.createElement("div", { className: 'success-title' }, successRelate.successTitle),
        successRelate.successSubTitle && (typeof successRelate.successSubTitle === 'string' ? react_1.default.createElement("div", { className: 'success-subtitle', dangerouslySetInnerHTML: { __html: successRelate.successSubTitle } }) : successRelate.successSubTitle),
        props.successRelate && props.successRelate.successMidSlot ?
            props.successRelate.successMidSlot : react_1.default.createElement(react_1.default.Fragment, null),
        successRelate.successBtnTitle && react_1.default.createElement("div", { className: 'success-btn', onClick: onClickClose }, successRelate.successBtnTitle));
};
exports.default = WithErrorHandler_1.WithErrorHandler(react_1.memo(Index));
